import { render, staticRenderFns } from "./insurance-bfs-report.vue?vue&type=template&id=321b0c02&scoped=true"
import script from "./insurance-bfs-report.vue?vue&type=script&lang=ts"
export * from "./insurance-bfs-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b0c02",
  null
  
)

export default component.exports